import useFetchFromBackend from "../../shared/lib/fetch-from-backed";

export default function useWorkflowList(queryParams = {}) {
  const { data, isLoading, error } = useFetchFromBackend({
    path: "/workflows",
    params: queryParams,
    queryKey: ["workflows", queryParams],
    options: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  });

  return { data, isLoading, error };
}
